import { Trans } from '@lingui/react'
import { type FunctionComponent } from 'react'

import PreQueryListItem from './PreQueryListItem'
import { type SearchSuggestion } from './types'

const TopProducts: FunctionComponent<ComponentProps> = ({ mobile, hits }) => {
  return (
    <div className="u-padding u-padding-x-small--bottom o-SearchBox__top-product">
      <strong className="o-SearchBox__top-searches-product__title">
        <Trans id="searchBox.label.popularProducts" />
      </strong>
      <ul className="a-list-reset o-SearchBox__list u-padding--top">
        {hits.map((hit, index) => (
          <PreQueryListItem
            mobile={mobile}
            key={hit.id}
            item={hit}
            last={index + 1 === hits.length}
            position={index + 1}
          />
        ))}
      </ul>
    </div>
  )
}

type ComponentProps = {
  hits: SearchSuggestion[]
  mobile?: boolean
}

export default TopProducts
